<div>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Status synchronizacji BDO</mat-card-title>
      <mat-card-subtitle>Podgląd statusu pobierania danych z BDO per podmiot</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px" style="margin-bottom: 16px">
        <mat-form-field appearance="outline" fxFlex="50%" fxFlex.lt-md="100%">
          <mat-label>Szukaj podmiotu</mat-label>
          <input matInput [(ngModel)]="filterValue" (ngModelChange)="applyFilter()" placeholder="Nazwa podmiotu..." />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <span style="font-size: 13px; color: rgba(0,0,0,0.54)">Auto-odświeżanie</span>
          <mat-slide-toggle [(ngModel)]="autoRefresh" color="primary"></mat-slide-toggle>
          <button mat-icon-button (click)="refresh()" matTooltip="Odśwież teraz">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>

      <mat-spinner *ngIf="loading" style="margin: 60px auto"></mat-spinner>

      <div *ngIf="!loading && !error && filteredStatuses.length === 0" style="text-align: center; padding: 40px; color: rgba(0,0,0,0.38)">
        Brak danych o synchronizacji. Synchronizacja podmiotów jeszcze się nie rozpoczęła.
      </div>

      <table mat-table [dataSource]="filteredStatuses" *ngIf="!loading && filteredStatuses.length > 0" style="width: 100%">
        <ng-container matColumnDef="subjectName">
          <th mat-header-cell *matHeaderCellDef>Podmiot</th>
          <td mat-cell *matCellDef="let row">
            <strong>{{ row.subjectName }}</strong>
            <div style="font-size: 11px; color: rgba(0,0,0,0.38)">{{ row.companyId }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-chip" [ngClass]="getStatusClass(row.lastResult)">
              {{ getStatusLabel(row.lastResult) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="phase">
          <th mat-header-cell *matHeaderCellDef>Faza</th>
          <td mat-cell *matCellDef="let row">{{ getPhaseLabel(row.currentPhase) }}</td>
        </ng-container>

        <ng-container matColumnDef="lastSync">
          <th mat-header-cell *matHeaderCellDef>Ostatnia synchronizacja</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="getAbsoluteTime(row.lastSyncCompleted)">
            {{ getRelativeTime(row.lastSyncCompleted) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cards">
          <th mat-header-cell *matHeaderCellDef>Kart przetworzonych</th>
          <td mat-cell *matCellDef="let row">{{ row.totalCardsProcessed }}</td>
        </ng-container>

        <ng-container matColumnDef="errors">
          <th mat-header-cell *matHeaderCellDef>Błędy</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.errorCount === 0" style="color: rgba(0,0,0,0.38)">0</span>
            <span *ngIf="row.errorCount > 0" class="error-badge" (click)="toggleExpand(row.companyId); $event.stopPropagation()">
              {{ row.errorCount }}
              <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle">
                {{ expandedCompanyId === row.companyId ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggleExpand(row.companyId)" style="cursor: pointer"
            [class.expanded-row]="expandedCompanyId === row.companyId"></tr>
      </table>

      <div *ngFor="let row of filteredStatuses">
        <div *ngIf="expandedCompanyId === row.companyId && row.lastError" class="error-detail-panel">
          <div class="error-detail-header">
            <mat-icon style="color: #e53935; font-size: 18px; height: 18px; width: 18px; margin-right: 8px">error</mat-icon>
            Ostatni błąd dla {{ row.subjectName }}
          </div>
          <pre class="error-detail-message">{{ row.lastError }}</pre>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
